// Captures landing page acquisition data (UTM params, affiliate codes, referrer)
// and stores in sessionStorage so it survives navigation but not browser restart.
// Data is read once during auth callback and sent to the backend for new users.

const STORAGE_KEY = 'jetogo_acquisition';

const TRACKED_PARAMS = [
  'utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content',
  'via',       // Afglo affiliate
  'ref',       // Generic referral
  'gclid',     // Google Ads
  'fbclid',    // Facebook Ads
  'msclkid',   // Microsoft Ads
];

/**
 * Call once on app init. Captures URL params + document.referrer on first landing.
 * Only writes if no acquisition data exists yet (preserves the original landing data).
 */
export function captureAcquisitionData() {
  try {
    if (sessionStorage.getItem(STORAGE_KEY)) return;

    const params = new URLSearchParams(window.location.search);
    const data = {};

    for (const key of TRACKED_PARAMS) {
      const val = params.get(key);
      if (val) data[key] = val;
    }

    if (document.referrer) {
      try {
        const ref = new URL(document.referrer);
        // Only store external referrers
        if (ref.hostname !== window.location.hostname) {
          data.referrer = document.referrer;
          data.referrer_domain = ref.hostname;
        }
      } catch {
        data.referrer = document.referrer;
      }
    }

    data.landing_page = window.location.pathname + window.location.search;
    data.captured_at = new Date().toISOString();

    sessionStorage.setItem(STORAGE_KEY, JSON.stringify(data));
  } catch {
    // sessionStorage may be unavailable in some contexts
  }
}

/**
 * Returns the captured acquisition data, or null if none exists.
 */
export function getAcquisitionData() {
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}
